"use client";

import "./Footer.css";

const Footer = () => {
    const cities = [
        "Chandigarh",
        "Delhi",
        "Bangalore",
        "Hyderabad",
        "Chennai",
        "Kolkata",
        "Pune",
        "Ahmedabad",
        "Jaipur",
        "Surat",
        "Lucknow",
        "Kanpur",
    ];

    const cuisines = [
        "North Indian",
        "South Indian",
        "Chinese",
        "Italian",
        "Mexican",
        "Thai",
        "Continental",
        "Desserts",
        "Beverages",
        "Fast Food",
        "Street Food",
        "Biryani",
    ];

    return (
        <footer className="modern-footer">
            {/* Decorative Background Elements */}
            <div className="footer-bg-elements">
                <div className="bg-circle circle-1"></div>
                <div className="bg-circle circle-2"></div>
                <div className="bg-circle circle-3"></div>
            </div>

            {/* Newsletter Section */}
            <div className="newsletter-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="newsletter-card">
                                <div className="newsletter-icon-wrapper">
                                    <i className="bi bi-envelope-heart newsletter-icon"></i>
                                </div>
                                <h3 className="newsletter-title">
                                    Stay Connected with Katchit
                                </h3>
                                <p className="newsletter-subtitle">
                                    Get exclusive offers, new restaurant
                                    updates, and food trends delivered to your
                                    inbox
                                </p>
                                <div className="newsletter-form-wrapper">
                                    <div className="newsletter-form">
                                        <input
                                            type="email"
                                            className="newsletter-input"
                                            placeholder="Enter your email address"
                                        />
                                        <button
                                            className="newsletter-btn"
                                            type="button"
                                        >
                                            <span>Subscribe</span>
                                            <i className="bi bi-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="footer-content">
                <div className="container">
                    <div className="row g-4">
                        {/* Company Info */}
                        <div className="col-lg-4 col-md-6">
                            <div className="footer-section company-section">
                                <div className="brand-wrapper">
                                    <div className="brand-logo-modern">
                                        <div className="logo-container">
                                            <img
                                                src="/assets/images/logo.png"
                                                alt="Katchit Logo"
                                                className="brand-logo-img"
                                            />
                                        </div>
                                        {/* <div className="brand-text">
                      <h3 className="brand-name">Katchit</h3>
                      <span className="brand-tagline">Fresh • Fast • Delicious</span>
                    </div> */}
                                    </div>
                                    <p className="company-description">
                                        Experience the future of Food delivery,Dine-Zone,Part Zone,Catering & Courier
                                        with our eco-friendly platform.
                                        Everything You Need, Deliverd with Care!.
                                    </p>

                                    {/* App Download */}
                                    <div className="app-download-section">
                                        <h5 className="download-heading">
                                            <i className="bi bi-download"></i>
                                            Download Our App
                                        </h5>
                                        <div className="app-buttons-grid">
                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.katchit.customer_app"
                                                className="footer-store-btn"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-label="Open Katchit on Google Play"
                                            >
                                                <img
                                                    src="/assets/play_store.avif"
                                                    alt="Get it on Google Play"
                                                    className="footer-store-img"
                                                />
                                            </a>

                                            <a
                                                href="https://apps.apple.com/in/app/katchit-customer/id6785157187"
                                                className="footer-store-btn"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-label="Open Katchit on the App Store"
                                            >
                                                <img
                                                    src="/assets/app_store.avif"
                                                    alt="Download on the App Store"
                                                    className="footer-store-img"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="col-lg-2 col-md-6">
                            <div className="footer-section">
                                <h4 className="section-title">
                                    <i className="bi bi-building"></i>
                                    Company
                                </h4>
                                <ul className="footer-links">
                                    <li>
                                        <a
                                            href="https://api.katchit.in/about.html"
                                            className="footer-link"  target="blank"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/hiring" className="footer-link">
                                            Hiring
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                              href="https://api.katchit.in/terms.html"
                                            className="footer-link"
                                        >
                                            Terms & Conditions
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a href="/team" className="footer-link">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/blog" className="footer-link">
                                            Blog
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/press"
                                            className="footer-link"
                                        >
                                            Press Kit
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/investor"
                                            className="footer-link"
                                        >
                                            Investors
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                        {/* Partners */}
                        <div className="col-lg-2 col-md-6">
                            <div className="footer-section">
                                <h4 className="section-title">
                                    <i className="bi bi-handshake"></i>
                                    Partners
                                </h4>
                                <ul className="footer-links">
                                    <li>
                                        <a
                                            href="https://vendor.katchit.in/signup" target="blank"
                                            className="footer-link"
                                        >
                                            Register Vendor
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a
                                            href="/restaurant-signup"
                                            className="footer-link"
                                        >
                                            Add Restaurant
                                        </a>
                                    </li> */}
                                    {/* <li>
                                        <a
                                            href="/delivery-partner"
                                            className="footer-link"
                                        >
                                            Delivery Partner
                                        </a>
                                    </li> */}
                                    {/* <li>
                                        <a
                                            href="/merchant-app"
                                            className="footer-link"
                                        >
                                            Merchant App
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/business"
                                            className="footer-link"
                                        >
                                            Business Solutions
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                        {/* Support */}
                        <div className="col-lg-2 col-md-6">
                            <div className="footer-section">
                                <h4 className="section-title">
                                    <i className="bi bi-headset"></i>
                                    Support
                                </h4>
                                <ul className="footer-links">
                                    <li>
                                        <a href="/help" className="footer-link">
                                            Help Center
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/#contact"
                                            className="footer-link"
                                        >
                                            Contact Us
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a
                                            href="/safety"
                                            className="footer-link"
                                        >
                                            Safety
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/refund"
                                            className="footer-link"
                                        >
                                            Refunds
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/report"
                                            className="footer-link"
                                        >
                                            Report Issue
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                        {/* Contact & Social */}
                        <div className="col-lg-2 col-md-6">
                            <div className="footer-section">
                                <h4 className="section-title">
                                    <i className="bi bi-chat-heart"></i>
                                    Connect
                                </h4>

                                {/* Contact Info */}
                                <div className="contact-info-modern">
                                    <div className="contact-item-modern">
                                        <i className="bi bi-geo-alt-fill"></i>
                                        <span>10203./4 floor Padam Singh road
Karol Bagh New Delhi -110005</span>
                                    </div>
                                    <div className="contact-item-modern">
                                        <i className="bi bi-telephone-fill"></i>
                                        <span>+91 9990323317</span>
                                    </div>
                                    <div className="contact-item-modern">
                                        <i className="bi bi-envelope-fill"></i>
                                        <span>info@katchit.in</span>
                                    </div>
                                </div>

                                {/* Social Media */}
                                <div className="social-section">
                                    <h6 className="social-heading">
                                        Follow Us
                                    </h6>
                                    <div className="social-links-modern">
                                        <a 
                                            href="https://www.facebook.com/share/19bLnDWWwF/" target="blank"
                                            className="social-link-modern facebook"
                                        >
                                            <i className="bi bi-facebook"></i>
                                        </a>
                                        {/* <a
                                            href="!#"
                                            className="social-link-modern twitter"
                                        >
                                            <i className="bi bi-twitter"></i>
                                        </a> */}
                                        <a
                                            href="https://www.instagram.com/katchit.in?igsh=MWpnOGMxZTBoN2Vqeg==" target="blank"
                                            className="social-link-modern instagram"
                                        >
                                            <i className="bi bi-instagram"></i>
                                        </a>
                                        {/* <a
                                            href="!#"
                                            className="social-link-modern linkedin"
                                        >
                                            <i className="bi bi-linkedin"></i>
                                        </a> */}
                                        <a
                                            href="!#"
                                            className="social-link-modern youtube"
                                        >
                                            <i className="bi bi-youtube"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Divider */}
                    <div className="footer-divider">
                        <div className="divider-line"></div>
                        <div className="divider-icon">
                            <i className="bi bi-heart-fill"></i>
                        </div>
                        <div className="divider-line"></div>
                    </div>

                    {/* Cities and Cuisines */}
                    <div className="row g-4 mb-5">
                        <div className="col-lg-6">
                            <div className="info-section">
                                <h5 className="info-title">
                                    <i className="bi bi-geo-alt"></i>
                                    We Will Delivering Soon to all Places
                                </h5>
                                <div className="info-grid">
                                    {cities.map((city, index) => (
                                        <a
                                            key={index}
                                            href={`/city/${city.toLowerCase()}`}
                                            className="info-item"
                                        >
                                            {city}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="info-section">
                                <h5 className="info-title">
                                    <i className="bi bi-cup-hot"></i>
                                    Popular Cuisines
                                </h5>
                                <div className="info-grid">
                                    {cuisines.map((cuisine, index) => (
                                        <a
                                            key={index}
                                            href={`/cuisine/${cuisine
                                                .toLowerCase()
                                                .replace(" ", "-")}`}
                                            className="info-item"
                                        >
                                            {cuisine}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer Bottom */}
                    <div className="footer-bottom">
                        <div className="row align-items-center">
                            <div className="col-md-8">
                                <div className="legal-links">
                                    {/* <a href="/privacy" className="legal-link">
                                        Privacy Policy
                                    </a> */}
                                    <a href="https://api.katchit.in/terms.html" target="blank" className="legal-link">
                                        Terms of Service
                                    </a>
                                    <a href="/cookies" className="legal-link">
                                        Cookie Policy
                                    </a>
                                    {/* <a href="/security" className="legal-link">
                                        Security
                                    </a> */}
                                </div>
                            </div>
                            <div className="col-md-4 text-md-end">
                                <p className="copyright">
                                    © {new Date().getFullYear()} Katchit.
                                    Designed by{" "}
                                    <span className="text-success">
                                        {" "}
                                        Mr. Lorick{" "}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll to Top Button */}
            <button
                className="scroll-top-btn"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
                <i className="bi bi-arrow-up"></i>
            </button>
        </footer>
    );
};

export default Footer;
